import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap, throwError } from 'rxjs';
import { FileService } from '../../shared/services/file.service';
import { ApiConstants } from '../../shared/constants/api-constants';
import { DocumentTemplate } from '../models/document-template';
import { DocumentTemplateAssignment } from '../models/document-template-assignment';
import { ScopeDocumentTemplates } from '../models/scope-document-templates';
import { EQMSScopeHierarchy } from '../../shared/models/scopes/eqms-scope-hierarchy';



@Injectable({
  providedIn: 'root'
})
export class DocumentTemplateManagementService {
  treeData:EQMSScopeHierarchy = {} as EQMSScopeHierarchy;
  constructor(private httpClient: HttpClient,
    private fileService: FileService) { }

  
  deleteFile(fileId: string): Observable<boolean> {
    return this.fileService.deleteFile(fileId);
  }
  deleteDocumentTemplate = (documentTemplate: DocumentTemplate[]): Observable<any> => {
    return of(true);
    //To Do : Integrate Original Service
  }

uploadDocumentTemplate = (file: File, foldername: string): Observable<any> => {
  return this.fileService.uploadFile(file, foldername).pipe(
    catchError((error: any) => {
      // Customize error message for document template context
      const customMessage =error.error.errorMessage;
      return throwError(() => customMessage);
    })
  );
}

  saveDocumentTemplate = (documentTemplate: DocumentTemplate): Observable<any> => {
    return this.httpClient.post(
      ApiConstants.Document_Templates_Api,
      documentTemplate
    );
  }
  updateDocumentTemplate = (documentTemplate: DocumentTemplate): Observable<any> => {
    return this.httpClient.put(
      ApiConstants.Document_Templates_Api,
      documentTemplate
    );
  }
  checkDocumentTemplateNameIsValid = (documentName: string, documentTemplateSavedName: string): Observable<any> => {
    if (documentName === documentTemplateSavedName) {
      return of(false);
    }
    return this.httpClient.get(ApiConstants.Document_Templates_Validate_Name_Api + `${documentName}`);
  }
  getDocumentTemplates = ()
    : Observable<any> => {
    return this.httpClient.get(ApiConstants.Document_Templates_Api);
  }

  downloadFile = (fileId: string)
    : Observable<any> => {
    return this.fileService.downloadFile(fileId);
  }
  deActiveDocumentTemplate = (fileId: String)
    : Observable<any> => {
    return this.httpClient.put(
      ApiConstants.DeActive_Document_Template_Api +
      `${fileId}`,
      {}
    );
  }
  loadDocumentTemplatesForScope = (documentTemplateAssignment: DocumentTemplateAssignment)
    : Observable<any> => {
    return this.httpClient.post(ApiConstants.Document_Templates_For_Scope_Api,documentTemplateAssignment);
  }
  updateDocumentTemplatesForScope = (scopeDocumentTemplates:ScopeDocumentTemplates) 
  : Observable<any> => {
    return this.httpClient.put(
      ApiConstants.Document_Templates_Update_For_Scope_Api,
      scopeDocumentTemplates
    );
  }

  getLinkedeQMSScopes = (documentTemaplateId: any): Observable<any> => {
    return this.httpClient.get(ApiConstants.GeteQMSScopes_Document_Template_Api + `${documentTemaplateId}`);
  }

  checkAccessibility=():Observable<any>=>{
    return this.httpClient.get(ApiConstants.CheckAccessibilityForLogedInUser);
  }

  getEQMSScopeForConfiguration(): Observable<EQMSScopeHierarchy> {
    let observable: Observable<EQMSScopeHierarchy>;
    if (Object.keys(this.treeData).length > 0) {
      observable = of(this.treeData);
    }
    else {
      observable = this.httpClient.get<EQMSScopeHierarchy>(ApiConstants.EQMSScopesForDocumentTemplateConfiguration_Api)
        .pipe(
          tap(treeData => this.treeData = treeData)
        );
    }
    return observable;
  }

}
